import { Component, OnInit } from '@angular/core';
import { DataService } from '../../../data.service';
@Component({
  selector: 'lc-verify',
  templateUrl: './verify.component.html',
  styleUrls: ['./verify.component.scss']
})
export class VerifyComponent implements OnInit {

  constructor(public dataService: DataService) { }

  ngOnInit() {
  }

  resend_email(){
    let email = this.dataService.subuser_info.email.toLowerCase();
    this.dataService.resend_email(email).subscribe(
      (details) => {
        console.debug(details);
        this.dataService.presentMessage('We sturen u een mail ter verificatie van uw e-mail adres.', 'success');
        // NOTE: the new user is logged in  (but not verified)
        },
        (error) => {
          console.warn(error);
          this.dataService.presentMessage('Er is helaas iets fout gegaan', 'error');
        });
  }

}



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/components/account-management/verify/verify.component.ts